// extracted by mini-css-extract-plugin
export var errorIcon = "_mo-1";
export var nameLogo = "_mo-0";